import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

type CardCornerLabelProps = {
  labelType?: 'new';
};

const getLabelTypes = (t: TFunction<'translation', undefined>) => ({
  new: {
    text: t('New!'),
    mainColor: '#FFC700',
    secondaryColor: '#AA8500',
    textColor: '#000',
  },
});

/* eslint-disable max-len */
export const CardCornerLabel = ({
  labelType = 'new',
}: CardCornerLabelProps) => {
  const { t } = useTranslation();

  const { text, mainColor, secondaryColor, textColor } =
    getLabelTypes(t)[labelType];

  return (
    <svg
      style={{ maxHeight: 87, maxWidth: 88 }}
      viewBox="0 0 88 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M84.5 9V2L77.5 9H84.5Z" fill={secondaryColor} />
      <path d="M10 82.5V76L3.5 82.5H10Z" fill={secondaryColor} />
      <path d="M84.5 2H45L3.5 43V82.5L84.5 2Z" fill={mainColor} />
      <text
        style={{ transform: 'rotate(-45deg)', fontWeight: '500' }}
        x="-17"
        y="53"
        fill={textColor}
      >
        {text}
      </text>
    </svg>
  );
};
